import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import BackToGameLink from '../components/BackToGameLink';
import RostersPanel from '../components/RostersPanel';
import TopBar from '../components/TopBar';
import { usePrefetchPlayers } from '../api/usePrefetchPlayers';
import { gameModeFromSearch, useGameStream } from '../hooks/useGameStream';
import { selectAllRosteredIds } from '../state/selectors';
import styles from './Rosters.module.css';

export default function Rosters(): JSX.Element {
  const { gamePk } = useParams();
  const [searchParams] = useSearchParams();
  const gamePkNum = gamePk ? Number(gamePk) : undefined;
  // Historical games get a one-shot snapshot, never a live SSE stream
  // (which would spin up a poller on a final game).
  const mode = gameModeFromSearch(searchParams);
  const { snapshot, status } = useGameStream(gamePkNum, { mode });

  // Warm the modal cache for every player visible on this page — a direct nav
  // to /rosters/123 should feel as instant as a click from GameView.
  const rosteredIds = useMemo(() => selectAllRosteredIds(snapshot), [snapshot]);
  usePrefetchPlayers(gamePkNum, rosteredIds);

  return (
    <>
      <TopBar />
      <main className={styles.page}>
        <div className={styles.pageHeader}>
          <BackToGameLink gamePk={gamePkNum} mode={mode} />
          <h1 className={styles.title}>Rosters</h1>
        </div>
        {status === 'connecting' && !snapshot && <p>Loading…</p>}
        <RostersPanel snapshot={snapshot} gamePk={gamePkNum} />
      </main>
    </>
  );
}
